export default "__VITE_ASSET__CySNnPVU__"